import type { SectionsListItem } from './list-draft';

export interface SectionsListDeleteResult {
  fallbackList: { id: number; name: string } | null;
  linkedAppIds: number[];
  reassignedApps: number;
  campaignSync?: { ok?: boolean } | null;
}

export const selectSectionsListFallbackId = (
  lists: SectionsListItem[],
  deletedListId: number
): number | null => {
  const available = lists
    .filter((candidate) => Number(candidate.sectionsList.id) !== deletedListId)
    .sort((left, right) => Number(left.sectionsList.id) - Number(right.sectionsList.id));
  const namedDefault = available.find((candidate) => /default/i.test(candidate.name || ''));
  return Number(namedDefault?.sectionsList.id || available[0]?.sectionsList.id) || null;
};

export const applySectionsListFallbackToApps = <T extends {
  id: number;
  offerwallParams?: any;
}>(
  apps: T[],
  deletedListId: number,
  fallbackListId: number | null,
  linkedAppIds: number[]
): T[] => {
  if (!fallbackListId) return apps;
  const linkedIds = new Set(linkedAppIds.map(Number));

  return apps.map((app) => {
    const referencesDeletedList = Number(app.offerwallParams?.sectionsListId) === deletedListId;
    if (!referencesDeletedList && !linkedIds.has(Number(app.id))) return app;

    return {
      ...app,
      offerwallParams: {
        ...app.offerwallParams,
        sectionsListId: fallbackListId,
      },
    } as T;
  });
};
